import { useWindowDimensions } from 'react-native';

type SizingParams = {
  min?: number;
  max?: number;
};

const constrain = (size: number, params?: SizingParams) => {
  let newSize = size;

  if (params?.min !== undefined && size < params.min) {
    newSize = params.min;
  }

  if (params?.max !== undefined && size > params.max) {
    newSize = params.max;
  }

  return newSize;
};

type Params = {
  baseWidth?: number;
  baseHeight?: number;
};

export const useResponsiveStyling = (baseSize?: Params) => {
  const { width, height } = useWindowDimensions();

  // These defaults are based off the standard A9 tablet we ship.
  const guidelineBaseWidth = baseSize?.baseWidth ?? 1280;
  const guidelineBaseHeight = baseSize?.baseHeight ?? 784.66667;

  const scale = (size: number, params?: SizingParams) => {
    const newSize = (width / guidelineBaseWidth) * size;
    return constrain(newSize, params);
  };

  const verticalScale = (size: number, params?: SizingParams) => {
    const newSize = (height / guidelineBaseHeight) * size;
    return constrain(newSize, params);
  };

  const moderateScale = (size: number, factor = 0.5, params?: SizingParams) => {
    const newSize = size + (scale(size) - size) * factor;
    return constrain(newSize, params);
  };

  const moderateVerticalScale = (
    size: number,
    factor = 0.5,
    params?: SizingParams
  ) => {
    const newSize = size + (verticalScale(size) - size) * factor;
    return constrain(newSize, params);
  };

  const s = scale;
  const vs = verticalScale;
  const ms = moderateScale;
  const mvs = moderateVerticalScale;

  return {
    scale,
    verticalScale,
    moderateScale,
    moderateVerticalScale,
    s,
    vs,
    ms,
    mvs,
  };
};
